import { useEffect } from 'react';
import { ADMIN_SESSION_CHECK_INTERVAL_MS, refreshAdminSession } from '../lib/adminSession';

export default function AdminSessionKeeper() {
  useEffect(() => {
    if (localStorage.getItem('admin_logged_in') !== 'true') return;

    const renew = () => {
      if (localStorage.getItem('admin_logged_in') === 'true') {
        void refreshAdminSession();
      }
    };

    renew();
    const timer = window.setInterval(renew, ADMIN_SESSION_CHECK_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, []);

  return null;
}
